<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
    <path
      d="M10.5007 38.4999C7.00065 41.4399 5.83398 50.1666 5.83398 50.1666C5.83398 50.1666 14.5607 48.9999 17.5007 45.4999C19.1573 43.5399 19.134 40.5299 17.2907 38.7099C16.3837 37.8443 15.189 37.3441 13.9358 37.3053C12.6827 37.2666 11.4594 37.692 10.5007 38.4999ZM28.0007 34.9999L21.0007 27.9999C22.2423 24.7786 23.8058 21.6907 25.6673 18.7833C28.3861 14.4362 32.1718 10.857 36.6643 8.38614C41.1569 5.91524 46.2069 4.63479 51.334 4.66659C51.334 11.0133 49.514 22.1666 37.334 30.3333C34.3863 32.1963 31.2596 33.7596 28.0007 34.9999Z"
      stroke="url(#paint0_linear_1610_6925)" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M21.0007 28.0002H9.33398C9.33398 28.0002 10.6173 20.9302 14.0007 18.6669C17.7807 16.1469 25.6673 18.6669 25.6673 18.6669M28.0007 35.0002V46.6669C28.0007 46.6669 35.0707 45.3835 37.334 42.0002C39.854 38.2202 37.334 30.3335 37.334 30.3335"
      stroke="url(#paint1_linear_1610_6925)" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" />
    <defs>
      <linearGradient id="paint0_linear_1610_6925" x1="6.90204" y1="9.15599" x2="53.8176" y2="30.5421"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#47D18C" />
        <stop offset="1" stop-color="#66A3FF" />
      </linearGradient>
      <linearGradient id="paint1_linear_1610_6925" x1="10.0175" y1="20.4204" x2="40.0434" y2="34.1077"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#47D18C" />
        <stop offset="1" stop-color="#66A3FF" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script lang="ts" setup>

</script>

<style></style>